import { Box, Flex, List, Modal, Text, TextInput } from '@mantine/core';
import { IconLocation, IconSearch } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { api } from '../services/master.service';

function CitySelectionModal({ opened, onClose }) {
  const [cities, setCities] = useState([]);
  const [counters, setCounters] = useState([]);
  const [showCounters, setShowCounters] = useState(false);

  useEffect(() => {
    api.get_cities().then((res) => {
      let data = res.data.data;
      let flat = data.flatMap((e) => e.city);
      setCities(flat);
    });
  }, []);

  useEffect(() => {
  const cityId = localStorage.getItem("city_id");
  if (cityId) {
    api.get_counters(cityId).then((res) => {
      if (res.success !== false) {
        setCounters(res.data); // backend already filtered
      }
    });
  }
}, []);

  return (
    <div>
      <Modal
        opened={opened}
        withCloseButton={false}
        //onClose={onClose}
        styles={{ header: { borderBottom: '1px solid #eee' }, body: { padding: 0 } }}
        title={
          <Box px={10}>
            <Flex align={'center'}>
              <IconLocation size={16} />
              <Text ml={14} size={'16px'}>
                {showCounters ? 'Your location near to' : 'Your city'}
              </Text>
            </Flex>
          </Box>
        }
        size={'400px'}
        centered
      >
        <Box p={20}>
          <TextInput placeholder="Search Area" icon={<IconSearch size={15} />} />
          <Box mt={20}>
            <List
              style={{
                padding: 0,
                listStyle: ' none',
              }}
              styles={{
                item: {
                  transition: 'all .1s ease',
                  '&:hover': {
                    background: '#eee',
                    cursor: 'pointer',
                  },
                },
              }}
            >
             {!showCounters &&
               cities.map((e) => (
                 <List.Item
                   key={e.id}
                   style={{
                     border: '1px solid #eee',
                     borderRadius: 10,
                     padding: '9px 18px',
                     fontSize: 13,
                     fontWeight: 500,
                     marginBottom: 13,
                   }}
                   onClick={() => {
                     localStorage.setItem('city_pincode', e.pincode);
                     localStorage.setItem('city_id', e.id);
                     localStorage.setItem('city_name', e.city);
                     api.get_counters(e.id).then((res) => {
                       if (res.success !== false) {
                         setCounters(res.data);
                         setShowCounters(true);
                       }
                     });
                   }}
                >
                  {e.city}
                </List.Item>
              ))}

                {showCounters &&
                  counters.map((c) => (
                    <List.Item
                      key={c.id}
                      style={{
                        border: '1px solid #eee',
                        borderRadius: 10,
                        padding: '9px 18px',
                        fontSize: 13,
                        fontWeight: 500,
                        marginBottom: 13,
                      }}
                      onClick={() => {
                        localStorage.setItem('counter_id', c.id);
                        localStorage.setItem('counter_name', c.name);
                        window.location.reload();
                      }}
                    >
                      {c.name}
                    </List.Item>
                    ))}

            </List>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}

export default CitySelectionModal;
